module.exports = __webpack_public_path__ + "img/14.712ca32.png";